import React from 'react';
import { Stack, Box } from '@mui/material';
import { useTheme, withStyles } from '@material-ui/core';
import { VTypography } from '@venti-components';
import styles from './styles';
import { Theme } from '../../../../types/theme';
import { ReactComponent as VisaIcon } from '../../../../assets/paymentMethods/card-brand/visa.svg';
import { ReactComponent as MastercardIcon } from '../../../../assets/paymentMethods/card-brand/mastercard.svg';
import { ReactComponent as AmexIcon } from '../../../../assets/paymentMethods/card-brand/amex.svg';

export enum CARD_TYPES {
  DEBIT = 'DEBITO',
  CREDIT = 'CREDITO',
}

interface Commerce {
  id?: number;
  issuerCode: string;
  regex: string;
  cardType: CARD_TYPES;
  bank: string;
  installments: Array<{
    installment: number;
    interest: number;
  }>;
}

interface LineCommercesProps {
  commerces: Commerce[];
}

const getCardType = (cardType: CARD_TYPES) => {
  switch (cardType) {
    case CARD_TYPES.CREDIT:
      return 'Crédito';
    case CARD_TYPES.DEBIT:
      return 'Débito';
    default:
      return 'Crédito o débito';
  }
};

const LineCommerces = ({
  classes,
  commerces,
}: LineCommercesProps & { classes: Record<string, string> }) => {
  const getCardBrand = (issuerCode: string) => {
    if (issuerCode.includes('MASTER')) {
      return <MastercardIcon className={classes.cardBrandIcon} />;
    }
    if (issuerCode.includes('AMEX')) {
      return <AmexIcon className={classes.cardBrandIcon} />;
    }
    if (issuerCode.includes('VISA')) {
      return <VisaIcon className={classes.cardBrandIcon} />;
    }

    return null;
  };
  const theme = useTheme<Theme>();
  const textSecondary = theme.palette.text.secondary;

  return (
    <Stack direction="row" gap={2} width="100%">
      {commerces?.map((commerce, index) => (
        <Box key={index} className={classes.cardContainer}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack mb={1}>
              <VTypography variant="body2" color={textSecondary}>
                Issuer Code
              </VTypography>
              <VTypography variant="body2">{commerce.issuerCode}</VTypography>
            </Stack>
            {getCardBrand(commerce.issuerCode)}
          </Stack>
          {commerce.id && (
            <Stack mb={1}>
              <VTypography variant="body2" color={textSecondary}>
                Venti / Line Commerce ID
              </VTypography>
              <VTypography variant="body2">{commerce.id}</VTypography>
            </Stack>
          )}
          <Stack mb={1}>
            <VTypography variant="body2" color={textSecondary}>
              Tarjetas
            </VTypography>
            <VTypography variant="body2">{getCardType(commerce.cardType)}</VTypography>
          </Stack>
          {commerce.bank && (
            <Stack mb={1}>
              <VTypography variant="body2" color={textSecondary}>
                Exclusividad Bancaria
              </VTypography>
              <VTypography variant="body2">{commerce.bank}</VTypography>
            </Stack>
          )}
          {commerce.installments?.length > 0 && (
            <Stack mb={1}>
              <VTypography variant="body2" color={textSecondary}>
                Cuotas disponibles
              </VTypography>
              <Stack direction="row" gap={1} mt={1} flexWrap="wrap">
                {commerce.installments?.map((inst, instIndex) => (
                  <Box key={instIndex} className={classes.installmentBox}>
                    <VTypography variant="body2">
                      {inst.installment} {inst.installment === 1 ? 'cuota' : 'cuotas'}
                    </VTypography>
                    <VTypography variant="body2" color={textSecondary}>
                      {inst.interest}% interés
                    </VTypography>
                  </Box>
                ))}
              </Stack>
            </Stack>
          )}
        </Box>
      ))}
    </Stack>
  );
};

export default withStyles(styles)(LineCommerces);
